<router-outlet></router-outlet>
<app-http-spinner></app-http-spinner>
